// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COUNSELLING_SHOW_MORE = "V\u00edce z poradny...";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
